import { render, staticRenderFns } from "./FilterWrap.vue?vue&type=template&id=5a24e2e3&scoped=true"
import script from "./FilterWrap.vue?vue&type=script&lang=js"
export * from "./FilterWrap.vue?vue&type=script&lang=js"
import style0 from "./FilterWrap.vue?vue&type=style&index=0&id=5a24e2e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a24e2e3",
  null
  
)

export default component.exports